import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { LoginScreenForms } from 'lib/enums/login.enums'
import { ILoginState } from './login.models'

const initialLoginState: ILoginState = {
  form: LoginScreenForms.LOGIN,
}

const loginSlice = createSlice({
  name: 'login',
  initialState: initialLoginState,
  reducers: {
    setActiveForm(state, action: PayloadAction<LoginScreenForms>) {
      state.form = action.payload
    },
    resetActiveForm() {
      return initialLoginState
    },
  },
})

export const { setActiveForm, resetActiveForm } = loginSlice.actions

export default loginSlice.reducer
